export const UPDATE_SEARCH_QUERY = 'UPDATE_SEARCH_QUERY'
export const UPDATE_MESSAGE_FILTER = 'UPDATE_MESSAGE_FILTER'

export const updateSearchQuery = (query) => ({
  type: UPDATE_SEARCH_QUERY,
  payload: query,
})

export const updateMessageFilter = (filter) => ({
  type: UPDATE_MESSAGE_FILTER,
  payload: filter,
})
